import * as images from "@/components/images/Images";
import { ServiceResourceCardProps } from "@/components/screen/global-components/services/ServiceResourceCard";

const contentCertified = {
  title: "Certified translations related resources",
  description: null,
} as const;

const serviceResourceCardsCertified: ServiceResourceCardProps[] = [
  {
    title: "How to get documents translated and approved for immigration",
    description:
      "Ensure your immigration documents meet USCIS requirements with certified translations. Learn about necessary certifications and how to avoid application delays.",
    imageUrl: images.ImageMap,
  },
  {
    title: "Translation for law firms",
    description:
      "Discover the complexities of legal document translation for law firms, including types, challenges, and essential translator skills.",
    imageUrl: images.ImageMap2,
  },
  {
    title: "What is a certified translation - a complete guide",
    description:
      "Discover the essentials of certified translations—what they are, when you need them, and how to obtain them—in our comprehensive guide.",
    imageUrl: images.ImageMap3,
  },
];

const serviceResourceCardsNotarized: ServiceResourceCardProps[] = [
    {
      title: 'Does USCIS require notarized translation?',
      description:
        'Discover when notarized translations are necessary for USCIS and why they might be crucial for your immigration documents.',
      imageUrl: images.ImageMap,
    },
    {
      title: 'How to get documents translated and approved for immigration',
      description:
        'Navigating immigration translations? This complete guide covers everything you need to know, from document types to the best translation practices for your application.',
      imageUrl: images.ImageMap2,
    },
    {
      title: 'What is a certified translation - a complete guide',
      description:
        'Explore the importance of certified translations in legal, medical, and official contexts. Learn what sets them apart and how to find the right services.',
      imageUrl: images.ImageMap3,
    },
  ];
  

const contentNotarized = {
    title: "Related resources",
    description: null,
  } as const;

export const servicesResourcesMap = {
  certified: {
    content: contentCertified,
    cards: serviceResourceCardsCertified,
  },
  notarized: {
    content: contentNotarized,
    cards: serviceResourceCardsNotarized,
  }
};
